import React from 'react';
import { useSelector } from 'react-redux';
import { PrescriptionItemInterface } from '../../../../interfaces/prescription';
import { PermissionsInterface } from '../../../../interfaces/drugstore';
import ItemsStatusInterface from '../../../../interfaces/itemsStatus';

import * as Styles from './CancellationStyles';
import { AppState } from '../../../../store';
import DispensedItemsList from './DispensedItemsList';
import PrescriptionActionsBar from './PrescriptionActionsBar';

interface Props {
  items: PrescriptionItemInterface[];
  cancelDispensation: Function;
  loadingItem: number | boolean;
  permissions: PermissionsInterface;
  itemsStatus: ItemsStatusInterface[];
}
// This component now composes the two extracted components

function Cancellation({
  items,
  cancelDispensation,
  loadingItem,
  permissions,
  itemsStatus,
}: Props): JSX.Element | null {
  const prescription = useSelector((state: AppState) => state.prescription.prescription);
  const showFullPrescriptionDownloadButton =
    useSelector((state: AppState) => state.prescription.showFullPrescriptionDownloadButton);

  if (items.length === 0) {
    return null;
  }

  return (
    <Styles.Container>
      <DispensedItemsList
        items={items}
        permissions={permissions}
        itemsStatus={itemsStatus}
        loadingItem={loadingItem}
        cancelDispensation={cancelDispensation}
        prescriptionId={prescription.id}
        prescriptionToken={prescription.token}
      />
      <PrescriptionActionsBar
        prescription={prescription}
        showFullPrescriptionDownloadButton={showFullPrescriptionDownloadButton}
      />
    </Styles.Container>
  );
}

export default Cancellation;
